var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"background-white module-navigation-bar ant-border-bottom radius-0"},[_c('div',{staticClass:"module-nav-header"},[_vm._v(" "+_vm._s(_vm.title)+" "),_vm._t("module-nav-header")],2),_c('div',{staticClass:"viewer-actions"},[_vm._t("module-nav-actions")],2),_c('div',{staticClass:"company-logo"},[_vm._t("module-nav-logo")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }